import React from 'react';
import { Select } from 'antd';

/**
 * The sort of a list of items, as one select that carries field AND direction
 * ("Newest first"). Its options come from `useListSort` (`selectProps` is
 * exactly what this takes), so the collection list and a related list offer the
 * same orders for the same card.
 *
 *   <SortSelect field="createdAt" direction="desc" options={…} onChange={…} />
 *
 * `onChange` receives the option's value, `<field>:<direction>`.
 */
export default function SortSelect({ field, direction, options, onChange, className = 'items-page__sort-field' }) {
	return (
		<Select
			className={className}
			value={`${field}:${direction}`}
			onChange={onChange}
			options={options}
			popupMatchSelectWidth={false}
			aria-label="Sort items"
		/>
	);
}
